import { render, staticRenderFns } from "./WaiterDetail.vue?vue&type=template&id=cea74176&scoped=true&lang=pug"
import script from "./WaiterDetail.vue?vue&type=script&lang=ts"
export * from "./WaiterDetail.vue?vue&type=script&lang=ts"
import style0 from "./WaiterDetail.vue?vue&type=style&index=0&id=cea74176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea74176",
  null
  
)

export default component.exports